import { registerBlockType } from '@wordpress/blocks';

import './style.css';

import metadata from './block.json';
import Edit from './edit';
import save from './save';
import deprecated from './deprecated';

import { defaultEnvelopeIcon } from '../../img/icons';

registerBlockType( metadata.name, {
  icon: defaultEnvelopeIcon,
  edit: Edit,
  save,
  deprecated
});
